var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table"},[_vm._t("header",null,{"columnWidths":_vm.columnWidths}),_vm._l((_vm.rows),function(row,index){return [_vm._t("default",function(){return [_c('row',{key:index,attrs:{"columnWidths":_vm.columnWidths,"data":row}})]},{"data":row,"columnWidths":_vm.columnWidths,"index":index})]})],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }